export const VISUAL_CHECK_RESULT = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  INCONCLUSIVE: 'INCONCLUSIVE',
};

export const VERIFICATION_RESULT = {
  HIGH_RISK: 'HIGH_RISK',
  LOW_RISK: 'LOW_RISK',
  INCONCLUSIVE: 'INCONCLUSIVE',
};

export const DOCUMENT_RISK_LEVEL = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};
